<template>
  <div class="homePage">
    <div class="top">
      <div class="navBg">
        <img src="@/assets/img/nav.png" alt />
      </div>
      <div class="navContent">
        <div class="logo">
          <img src="@/assets/img/logo.png" alt />
        </div>
        <div class="list">
          <div
            :class="pageIndex == 1 ? 'item choose' : 'item'"
            @click="changePage(1)"
          >
            我是中医
          </div>
          <div
            :class="pageIndex == 2 ? 'item choose' : 'item'"
            @click="changePage(2)"
          >
            煎药中心
          </div>
          <div
            :class="pageIndex == 3 ? 'item choose' : 'item'"
            @click="changePage(3)"
          >
            我是用户
          </div>
          <div
            :class="pageIndex == 4 ? 'item choose' : 'item'"
            @click="changePage(4)"
          >
            关于我们
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper" ref="Bscroll">
      <div class="content">
        <router-view @getMessage="showMsg" @getImgState="showState" />
        <bottom-nav></bottom-nav>
      </div>
    </div>
    <van-overlay
      class="overlay"
      :show="imgState"
      :lock-scroll="false"
      @click="imgState = false"
    >
      <div class="imgWrapper">
        <img :src="imgString" alt="" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Bscroll from 'better-scroll'
import bottomNav from './components/Bottom'
export default {
  name: 'Homepage',
  components: {
    bottomNav
  },
  data () {
    return {
      Bscroll: null,
      pageIndex: 1,
      imgState: false,
      imgString: ''
    }
  },
  mounted () {
    const options = {
      bounce: false,
      click: true,
      taps: true,
      tap: true,
      mouseWheel: true
    }
    this.Bscroll = new Bscroll(this.$refs.Bscroll, options)
    console.log(this.$route)
    if (this.$route.path === '/doctor') {
      this.pageIndex = 1
    } else if (this.$route.path === '/center') {
      this.pageIndex = 2
    } else if (this.$route.path === '/user') {
      this.pageIndex = 3
    } else {
      this.pageIndex = 4
    }
  },
  methods: {
    changePage (i) {
      this.pageIndex = i
      this.Bscroll.scrollTo(0, 0, 500)
    },
    showMsg (str) {
      this.imgString = str
    },
    showState (state) {
      this.imgState = state
    }
  },
  watch: {
    pageIndex () {
      if (this.pageIndex === 1) {
        this.$router.replace('/doctor')
      } else if (this.pageIndex === 2) {
        this.$router.replace('/center')
      } else if (this.pageIndex === 3) {
        this.$router.replace('/user')
      } else {
        this.$router.replace('/about')
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
@import '~@/assets/styles/varibles.styl'

.homePage
  width 100%
  height 100%

  .top
    width 100%
    height 80px
    display flex
    flex-direction row
    justify-content center
    align-items center
    position absolute
    left 0
    right 0
    top 0
    z-index 1
    box-shadow 0 4px 10px rgba(0, 0, 0, 0.1)

    .navBg
      width 100%
      overflow hidden
      display flex
      flex-direction row
      justify-content center
      align-items center
      position absolute
      left 0
      right 0
      top 0
      z-index -1

      img
        width 100%
        min-width 2560px
        height 80px

    .navContent
      width 1280px
      height 100%
      min-width 1280px
      margin 0 auto
      display flex
      flex-direction row
      justify-content space-between
      align-items center

      .logo
        width 140px
        margin-left 50px

        img
          width 100%

      .list
        display flex
        flex-direction row
        justify-content center
        align-items center
        margin-right 40px

        .item
          font-size 18px
          font-weight 400
          color rgba(0, 0, 0, 1)
          line-height 22px
          margin 0 10px
          cursor pointer

        .choose
          font-size 20px
          padding 10px 0
          border-bottom 2px solid #D70C19

  .wrapper
    position fixed
    left 0
    right 0
    bottom 0
    top 80px
    overflow hidden
    z-index 0

.overlay
  top 80px
  bottom 0
  display flex
  flex-direction row
  justify-content center
  align-items center
  .imgWrapper
    width 100%
    height 90%
    display flex
    flex-direction row
    justify-content center
    align-items center
    img
      height 85%
      display block

@media screen and (max-width 1279px)
  .overlay
    top 1.0667rem

  .homePage
    .navBg
      width 100%
      height 1.0667rem

      img
        width 100%

    .top
      width 100%
      height 1.0667rem

      .navContent
        width 100%
        min-width 0

        .logo
          margin-left 0.4rem
          width 2rem

        .list
          margin-right 0.4rem

          .item
            font-size 0.1867rem
            font-weight 400
            color rgba(0, 0, 0, 1)
            line-height 0.2133rem
            margin 0 0.1333rem
            cursor pointer

          .choose
            font-size 0.24rem
            padding 0.1333rem 0
            border-bottom 0.0267rem solid #D70C19

    .wrapper
      top 1.0667rem
</style>



// WEBPACK FOOTER //
// src/views/Homepage/homepage.vue